import { render } from "./import_list.vue?vue&type=template&id=2d0a9ba4"
import script from "./import_list.vue?vue&type=script&lang=js"
export * from "./import_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__